import Logo from './Logo';
import { Link } from '../hooks/useRouter';
import { COMPANY, NAV } from '../content/copy';

export default function Footer({ theme, onPrivacy, onTerms, onContact }) {
  const year = new Date().getFullYear();

  return (
    <footer className="bv-footer">
      <div className="bv-wrap">
        <div className="bv-footer-top">
          <Logo size={24} theme={theme === 'dark' ? 'dark' : 'light'} />
          <nav className="bv-footer-links" aria-label="Footer">
            {NAV.map((item) => (
              <Link key={item.path} to={item.path}>{item.label}</Link>
            ))}
          </nav>
          <div className="bv-footer-actions">
            <a className="bv-footer-product" href={COMPANY.productUrl} target="_blank" rel="noreferrer">
              civil3d.app →
            </a>
            {onContact && (
              <button type="button" className="bv-btn bv-btn-solid bv-footer-cta" onClick={onContact}>
                Contact us <span aria-hidden="true">→</span>
              </button>
            )}
          </div>
        </div>
        <div className="bv-footer-bot">
          <div>© {year} {COMPANY.name} · {COMPANY.domain}</div>
          <div className="bv-footer-legal">
            <button type="button" onClick={onPrivacy}>Privacy</button>
            <button type="button" onClick={onTerms}>Terms</button>
          </div>
          <p className="bv-footer-note">
            civil3d is in active research and development. Outputs should not be used as the sole basis for structural, legal, or safety-critical decisions.
          </p>
        </div>
      </div>
    </footer>
  );
}
